export default IconBrandInertia => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-brand-inertia" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M12.5 8l4 4l-4 4h4.5l4 -4l-4 -4z" />
  <path d="M3.5 8l4 4l-4 4h4.5l4 -4l-4 -4z" />
</svg>`;